import React from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Empty, Input, Pagination, Row, Spin} from "antd";
import ItemRevealFast from "./ItemRevealFast";
import Sticky from 'react-sticky-fill'

const EmptyImage = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA2NCA0MSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

class ExpandedList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      closedSections: {},
      error: null,
      page: 1,
      pageSize: 20,
      loading: props.loading || false,
    };
  }

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    index: PropTypes.arrayOf(PropTypes.object).isRequired,
    derivedKey: PropTypes.func,
    renderTop: PropTypes.func.isRequired,
    renderContent: PropTypes.func.isRequired,
    renderHeading: PropTypes.func,
    onPageChange: PropTypes.func,
    emptyText: PropTypes.string,
    serverSidePagination: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    const { page, pageSize } = this.state;
    const { index, items, loading } = this.props;
    const { index: prevIndex, items: prevItems, loading: prevLoading } = prevProps;
    if (index !== prevIndex && ((page - 1) * pageSize) > index.length) {
      this.setState({ page: 1 });
    }
    if (items !== prevItems || loading !== prevLoading) {
      this.setState({ loading: loading || false })
    }
  }

  handleClick = id => {
    const { closedSections } = this.state;
    const isOpen = !closedSections[id];
    this.setState({
      closedSections: {
        ...closedSections,
        [id]: !!isOpen
      }
    });
  };

  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }

  setExpansion = (value) => {
    const { index } = this.props;

    let newValues = {};
    index.forEach(id => newValues[id] = value);
    this.setState({
      closedSections: newValues
    });
  };

  setPagination = (page, pageSize) => {
    const { onPageChange, serverSidePagination } = this.props;
    this.setState({ page, loading: !!serverSidePagination });
    onPageChange && onPageChange(page, pageSize);
  };

  setPageSize = (current, size) => {
    const { index, onPageChange, serverSidePagination } = this.props;
    this.setState({ pageSize: size, loading: !!serverSidePagination });

    let page = current;
    const max_page = index / size - 1;
    if (page > max_page) {
      page = max_page;
      this.setState({ page });
    }

    onPageChange && onPageChange(page, size);
  };

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <React.Fragment>
          {error.toString()}
        </React.Fragment>
      );
    }
    const { renderTop, renderContent, renderHeading, derivedKey, style, emptyText, serverSidePagination } = this.props;
    let { index, items, extra, subExtra } = this.props;
    index = index || [];
    items = items || [];
    const { closedSections, page, pageSize } = this.state;

    const isEmpty = obj => { for (let x in obj) { return false; } return true; };
    const itemids = items.map(i => i.resource.id);
    const orderedItems = isEmpty(index) ? [] : index.filter(i => itemids.includes(i)).map(i => items.find(e => i === e.resource.id));

    const pageItems = serverSidePagination ? orderedItems : orderedItems.slice((page-1)*pageSize, page*pageSize);

    const InputGroup = Input.Group;

    const renderExpandButton = () => <Button
      type='secondary'
      icon='arrows-alt'
      onClick={() => this.setExpansion(false)}
    >
      <span className='hidden inline visible-lg'>Expand All</span>
    </Button>;

    const renderCollapseButton = () => <Button
      type='secondary'
      icon='shrink'
      onClick={() => this.setExpansion(true)}
    >
      <span className='hidden inline visible-lg'>Collapse All</span>
    </Button>;

    const renderListControls = () => <InputGroup compact>
      {renderExpandButton()}
      {renderCollapseButton()}
      {extra}
    </InputGroup>;

    return (
      <div style={style} className='expanded-list'>
        <div className='list-control control-top'>
          <Row className='controls'>
            <Col xs={0} md={24}>
              <div>
                <Pagination
                  simple
                  showSizeChanger
                  total={index.length}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                  current={page}
                  onChange={this.setPagination}
                  onShowSizeChange={this.setPageSize}
                  pageSize={pageSize}
                />
                <div>
                  {renderListControls()}
                  {subExtra}
                </div>
              </div>
            </Col>
            <Col xs={24} md={0}>
              <div>
                {renderListControls()}
                {subExtra}
              </div>
            </Col>
            <Col xs={24} md={0}>
              <Pagination
                showSizeChanger
                size='small'
                total={index.length}
                current={page}
                onChange={this.setPagination}
                onShowSizeChange={this.setPageSize}
                pageSize={pageSize}
              />
            </Col>
          </Row>
        </div>
        <Sticky className='list-heading' style={{zIndex: 2}}>
          {renderHeading && renderHeading()}
        </Sticky>
        <Spin spinning={this.state.loading}>
        {
          (this.state.loading) ? <Empty className={'ant-empty-normal'} image={Empty.PRESENTED_IMAGE_SIMPLE} description={'Loading'} /> :
            (!pageItems || !pageItems.length) ? <Empty
                description={emptyText || 'No results found.'} className={'ant-empty-normal'} image={EmptyImage}
              /> :
          pageItems.map((item, idx) => {
            let key = derivedKey ? derivedKey(item) : item.id;
            return (
              <ItemRevealFast
                key={key}
                id={key}
                item={item}
                renderBody={renderContent}
                renderTop={renderTop}
                open={!closedSections[key]}
                className='list-item'
                onClick={this.handleClick}
              />
            );
          })
        }
        </Spin>
        <Row>
          <Col xs={0} md={24}>
            <div className='list-control control-bottom'>
              <Pagination
                showSizeChanger
                total={index.length}
                showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                current={page}
                onChange={this.setPagination}
                onShowSizeChange={this.setPageSize}
                pageSize={pageSize}
              />
            </div>
          </Col>
          <Col xs={24} md={0}>
            <div className='list-control control-bottom'>
              <Pagination
                showSizeChanger
                size='small'
                total={index.length}
                current={page}
                onChange={this.setPagination}
                onShowSizeChange={this.setPageSize}
                pageSize={pageSize}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ExpandedList;



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ExpandedList.js